<template>
  <div v-if="currentType == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar Tipo de Experiencia</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <experience-type-form :entity="currentType" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import ExperienceTypeForm from "./ExperienceTypeForm.vue";


    const store = useStore();
    const route = useRoute();


    const getCurrentType = async (id) => {
      return await store.dispatch("experienceType/getTypeById", id);
    };

    const currentType = computed(() => store.state.experienceType.currentType);

    onMounted(() => {
      getCurrentType(route.params.id)
    });



</script>
